<template>
  <v-layout wrap>
    <v-flex xs12>
      <p
        class="text-xs-left mb-0 mt-3 body-2 grey--text text--darken-2"
        style="font-weight:600;"
      >Endereço</p>
    </v-flex>

    <v-flex sm6 md2>
      <v-text-field
        :disabled="disableFields"
        v-model="formData.zipcode"
        mask="#####-###"
        label="CEP"
        :rules="$store.state.formRules.required"
        @keyup="getAddress(formData.zipcode)"
        required
      ></v-text-field>
    </v-flex>
    <v-flex sm6 md5>
      <v-text-field
        :disabled="disableFields"
        v-model="formData.address"
        label="Logradouro"
        :rules="$store.state.formRules.required"
        required
      ></v-text-field>
    </v-flex>
    <v-flex xs12 sm6 md2>
      <v-text-field
        :disabled="disableFields"
        v-model="formData.number_address"
        label="Número"
        :rules="$store.state.formRules.required"
        required
      ></v-text-field>
    </v-flex>
    <v-flex sm6 md3>
      <v-text-field :disabled="disableFields" v-model="formData.complement" label="Complemento"></v-text-field>
    </v-flex>
    <v-flex xs12 sm6 md6>
      <v-text-field
        :disabled="disableFields"
        v-model="formData.district"
        label="Bairro"
        :rules="$store.state.formRules.required"
        required
      ></v-text-field>
    </v-flex>
    <v-flex xs12 sm6 md4>
      <v-text-field
        :disabled="disableFields"
        v-model="formData.city"
        label="Cidade"
        :rules="$store.state.formRules.required"
        required
      ></v-text-field>
    </v-flex>
    <v-flex xs12 sm6 md2>
      <v-text-field
        :disabled="disableFields"
        v-model="formData.state"
        label="Estado"
        :rules="$store.state.formRules.required"
        required
      ></v-text-field>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'AddressForm',

  props: {
    disableFields: { type: Boolean, default: false },
    editedData: Object,
    loadAddress: Function
  },

  computed: {
    formData () {
      return this.editedData
    }
  },

  methods: {
    getAddress (val) {
      if (val.length > 7) {
        this.$store.dispatch('request/addressByZipcode', val).then(response => {
          if (response) {
            this.loadAddress(response)
          }
        })
      }
    }
  }
}
</script>

<style>
</style>
